"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    tableName: {
      fontWeight: "bold"
    },
    viewItem: {
      cursor: "pointer",
      display: "flex",
      height: 36,
      alignItems: "center",
      padding: "0.25rem",
      borderRadius: "0.25rem"
    },
    btnHoverDisable: {
      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    listItemView: {
      borderRadius: 3,
      padding: "9px 35px 9px 12px",
      width: "auto",
      height: 32,
      marginRight: 5,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overFlow: "hidden"
    },
    flexContainer: {
      display: "flex",
      flexDirection: "row",
      padding: 0,
      maxWidth: "calc(100vw - 447px)"
    },
    closeButton: {
      height: 20,
      padding: "0.25rem",
      borderRadius: "0.25rem"
    },
    header: {
      padding: "20px 15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    toolbar: {
      height: 44,
      backgroundColor: "#fff",
      padding: "6px 12px",
      boxShadow: "rgb(0 0 0 / 10%) 0 1px 0 0"
    },
    viewIcon: {
      color: "red",
      fontSize: 14
    },
    viewTitle: {
      fontWeight: "bold",
      fontSize: 13,
      marginLeft: 5
    },
    divider: {
      height: 15,
      borderRight: "1px solid #D1D1D1"
    }
  };
});
var _default = useStyles;
exports["default"] = _default;